import * as actionTypes from './ActionTypes';

export const back_from_simulated_test = () => {
  return {
    type: actionTypes.BACK_FROM_CURRENT_SCREEN,
  };
};

export const gotoSimulatedTest = (questionBody, callback = () => {
}) => {
  return {
    type: actionTypes.GOTO_SIMULATED_TEST,
    questionBody: questionBody,
    callback,
  };
};

export const submit_simulated_test_scores = (
  simulated_test_score_body,
  dashboardFetch,
  success,
  callback,
) => {
  return {
    type: actionTypes.SUBMIT_SIMULATED_TEST_RESULT,
    simulated_test_score_body: simulated_test_score_body,
    dashboardFetch: dashboardFetch,
    success,
    callback,
  };
};

export const submit_challenge_complete_results = (params, callback) => {
  return {
    type: actionTypes.SUBMIT_CHALLENGE_HISTORY,
    body: params,
    callback,
  };
};

export const submit_challenge_request = (
  submit_challenge_request_body,
  callback,
) => {
  return {
    type: actionTypes.SUBMIT_CHALLENGE_REQUEST,
    body: submit_challenge_request_body,
    callback,
  };
};

export const setSimulatedQuestionByTopicId = (
  questionArray,
  numberOfQuestionsList,
  testTime,
) => {
  return {
    type: actionTypes.LIST_OF_SIMULATED_QUESTIONS,
    questionArray: questionArray,
    numberOfQuestionsList: numberOfQuestionsList,
    testTime: testTime,
  };
};

export const updateChallengeStatus = (value) => {
  return {
    type: actionTypes.UPDATE_CHALLENGE_STATUS,
    value,
  };
};

/*********** */
